var render = function render(){var _vm=this,_c=_vm._self._c;return (parseInt(_vm.errors.items.length))?_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"alert alert-danger"},[_c('ul',_vm._l((_vm.errors.items),function(error){return _c('li',[_vm._v(_vm._s(error.msg))])}),0)])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }